import { Switch, Route, Redirect } from 'react-router-dom';
import {
  NewRequestPage,
  EarlyTermination,
  EarlyTerminationSuccess,
} from 'modules/newRequestPage';
import { ActionsPathsEnum } from 'modules/newRequestPage/routes';
import { ContractsPage } from 'modules/contractsPage';
import {
  ContractsOverviewKeys,
  getContractsOverviewPageUrl,
} from 'modules/contractsOverviewPage/components/layout/helper';
import { ContractsOverviewPage } from 'modules/contractsOverviewPage';
import { InboxPage } from 'modules/inboxPage';
import { ContractPathsEnum } from 'modules/contractsPage/routes';
import { ContractOverviewPathsEnum } from 'modules/contractsOverviewPage/routes';
import { BillPathsEnum } from 'modules/billsPage/routes';
import { BillsPage } from 'modules/billsPage';
import { InboxPathsEnum } from 'modules/inboxPage/routes';
import { LeasingCalculatorPathsEnum } from 'modules/leasingCalculator/routes';
import { LeasingCalculatorPage } from 'modules/leasingCalculator';
import { ContactPathsEnum } from 'modules/contactPage/routes';
import { ContactPage } from 'modules/contactPage';
import { Homepage } from 'modules/homePage';
import { DocumentationList } from '../modules/documentationPage/components/DocumentationList';
import { DocumentationPathsEnum } from '../modules/documentationPage/routes';
import { UploadPageMobile } from '../modules/documentationPage/components/UploadPageMobile';
import { ProfilePathsEnum } from '../modules/profilePage/routes';
import { ProfilePageKeys, ProfilePageLayout } from '../modules/profilePage';
import {
  ContractsTabKeys,
  getContractsPageUrl,
} from '../modules/contractsPage/components/helper';
import { SimpleLeasingOfferOverviewPage } from '../modules/leasingOfferOverviewPage/components/simpleOfferOverviewPage';

export const LoggedInRoutes = () => (
  <Switch>
    {/* Home page */}
    <Route path="/" component={Homepage} exact />
    {/* profile page */}
    <Route
      path={ProfilePathsEnum.profilePage}
      render={() => <ProfilePageLayout tab={ProfilePageKeys.Information} />}
      exact
    />
    <Route
      path={`${ProfilePathsEnum.profilePage}/:tab`}
      exact
      render={({ match }) => {
        const matchParams: {
          tab: string;
        } = {
          tab: match.params.tab,
        };
        return <ProfilePageLayout {...matchParams} />;
      }}
    />
    {/* Documentation */}
    <Route
      path={DocumentationPathsEnum.documentationPage}
      component={DocumentationList}
      exact
    />
    <Route
      path={DocumentationPathsEnum.mobileUploadPage}
      component={UploadPageMobile}
      exact
    />
    {/* Actions */}
    <Route
      path={ActionsPathsEnum.newRequestPage}
      component={NewRequestPage}
      exact
    />
    <Route
      path={ActionsPathsEnum.newEarlyTerminationRequest}
      component={EarlyTermination}
      exact
    />
    <Route
      path={ActionsPathsEnum.earlyTerminationRequestSuccess}
      component={EarlyTerminationSuccess}
      exact
    />
    {/* Contracts */}
    <Route
      path={ContractPathsEnum.contracts}
      exact
      render={() => (
        <Redirect to={getContractsPageUrl(ContractsTabKeys.Active)} />
      )}
    />
    <Route
      path={`${ContractPathsEnum.contracts}/:tab`}
      exact
      render={({ match }) => {
        const tabEnum = Object.values(ContractsTabKeys).find(
          (key) => key === match.params.tab,
        );
        if (tabEnum) {
          const matchParams: {
            tab: ContractsTabKeys;
          } = {
            tab: tabEnum,
          };
          return <ContractsPage {...matchParams} />;
        }
        return <Redirect to={ContractPathsEnum.contracts} />;
      }}
    />
    {/* Contract Overview */}
    <Route
      path={`${ContractOverviewPathsEnum.contractsOverview}/:number`}
      exact
      render={({ match }) => {
        const { number } = match.params;

        return (
          <Redirect
            to={getContractsOverviewPageUrl(
              number,
              ContractsOverviewKeys.Details,
            )}
          />
        );
      }}
    />
    <Route
      path={`${ContractOverviewPathsEnum.contractsOverview}/:number/:tab`}
      exact
      render={({ match }) => {
        const tabEnum = Object.values(ContractsOverviewKeys).find(
          (key) => key === match.params.tab,
        );

        const { number } = match.params;

        if (tabEnum) {
          const matchParams: {
            tab: ContractsOverviewKeys;
            number: string;
          } = {
            tab: tabEnum,
            number,
          };
          return <ContractsOverviewPage {...matchParams} />;
        }
        return <Redirect to={ContractOverviewPathsEnum.contractsOverview} />;
      }}
    />
    {/* Bills */}
    <Route path={BillPathsEnum.bills} component={BillsPage} exact />
    {/* Inbox */}
    <Route path={InboxPathsEnum.inboxPage} component={InboxPage} exact />
    {/* Contact Form */}
    <Route path={ContactPathsEnum.contactPage} component={ContactPage} exact />
    {/* Leasing Calculator - basic calculator + ponuda */}
    <Route
      path={LeasingCalculatorPathsEnum.leasingCalculator}
      exact
      render={() => <LeasingCalculatorPage showInfoCalculation />}
    />
    <Route
      path={`${LeasingCalculatorPathsEnum.leasingCalculator}/${LeasingCalculatorPathsEnum.success}`}
      exact
      render={() => <LeasingCalculatorPage showInfoCalculation />}
    />
    <Route
      path={`${LeasingCalculatorPathsEnum.leasingCalculator}/offer`}
      exact
      render={() => <SimpleLeasingOfferOverviewPage />}
    />
    {/*
    <Route
      path={`${LeasingCalculatorPathsEnum.leasingCalculator}/:step?/:tab?`}
      exact
      render={({ match }) => {
        const matchParams: {
          step?: number;
        } = {
          step: match.params.step ? +match.params.step : undefined,
        };

        return <LeasingCalculatorPage {...matchParams} />;
      }}
    />
    <Route
      path={LeasingOffersPathsEnum.leasingOffers}
      exact
      render={() => (
        <Redirect to={getLeasingOfferPageUrl(LeasingOffersKeys.Active)} />
      )}
    />
    <Route
      path={`${LeasingOffersPathsEnum.leasingOffers}/:tab`}
      exact
      render={({ match }) => {
        const tabEnum = Object.values(LeasingOffersKeys).find(
          (key) => key === match.params.tab,
        );
        if (tabEnum) {
          const matchParams: {
            tab: LeasingOffersKeys;
          } = {
            tab: tabEnum,
          };
          return <LeasingOffersPage {...matchParams} />;
        }
        return <Redirect to={LeasingOffersPathsEnum.leasingOffers} />;
      }}
    />
    <Route
      path={`${LeasingOffersPathsEnum.leasingOffers}/:offerNumber/:tab`}
      exact
      render={({ match }) => {
        const tabEnum = Object.values(LeasingOfferOverviewTab).find(
          (key) => key === match.params.tab,
        );
        if (tabEnum) {
          const matchParams: {
            tab: LeasingOfferOverviewTab;
            offerNumber: string;
          } = {
            tab: tabEnum,
            offerNumber: match.params.offerNumber,
          };
          return <LeasingOfferOverviewPage {...matchParams} />;
        }
        return <Redirect to={LeasingOffersPathsEnum.leasingOffers} />;
      }}
    />
    */}
    <Redirect to="/" />
  </Switch>
);
